module.exports = __webpack_public_path__ + "img/loading.c2147ac3.gif";